import { render } from "./ResetPassword.vue?vue&type=template&id=4f7b1e58&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=4f7b1e58&scoped=true&lang=scss"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7b1e58"]])

export default __exports__